// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loading-screen {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  text-align: center;\n  padding-top: 10vh;\n  z-index: 9999;\n}\n.loading-screen .glyphicon {\n  font-size: 5em;\n}\n", ""]);
// Exports
module.exports = exports;
